var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import ArrowIcon from "@mui/icons-material/ArrowDropDownRounded";
import styles from "./AverageScore.module.scss";
var Box = function (_a) {
    var _b;
    var len = _a.length, value = _a.value, show = _a.show, target = _a.target, isProjectSingleSelect = _a.isProjectSingleSelect, aboveTargetColor = _a.aboveTargetColor, belowTargetColor = _a.belowTargetColor, _c = _a.perBoxScore, perBoxScore = _c === void 0 ? 1 : _c, getLeftOffset = _a.getLeftOffset, colorDecider = _a.colorDecider, pageType = _a.pageType;
    var length = typeof len == "number" ? len : 0;
    var val = (length / perBoxScore) * 100;
    var valueRounded = (_b = value === null || value === void 0 ? void 0 : value.toFixed(1)) !== null && _b !== void 0 ? _b : 0;
    var factorScoreColor = colorDecider(valueRounded);
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: styles.boxContainer }, { children: [show && (_jsx("div", __assign({ className: styles.targetValueBox, style: {
                        left: getLeftOffset(val, value),
                    } }, { children: valueRounded }))), _jsx("div", { className: styles.filledContainer, style: {
                        backgroundColor: isProjectSingleSelect && pageType && target !== undefined
                            ? valueRounded >= target
                                ? aboveTargetColor || "#2CA744"
                                : belowTargetColor || "#CD37A3"
                            : factorScoreColor,
                        width: "".concat(val, "%"),
                        borderTopRightRadius: val > 6 ? "15px" : "0px",
                        borderBottomRightRadius: val > 6 ? "15px" : "0px",
                    } }), length != perBoxScore && (_jsx("div", { className: styles.emptyBorderContainer, style: {
                        width: "".concat(100 - val, "%"),
                    } }))] })) }));
};
var Scrollbar = function (_a) {
    var _b;
    var score = _a.score, target = _a.target, isProjectSingleSelect = _a.isProjectSingleSelect, _c = _a.scale, scale = _c === void 0 ? 4 : _c, _d = _a.start, start = _d === void 0 ? 1 : _d, _e = _a.end, end = _e === void 0 ? 5 : _e, aboveTargetColor = _a.aboveTargetColor, belowTargetColor = _a.belowTargetColor, getLeftOffset = _a.getLeftOffset, colorDecider = _a.colorDecider, pageType = _a.pageType, props = __rest(_a, ["score", "target", "isProjectSingleSelect", "scale", "start", "end", "aboveTargetColor", "belowTargetColor", "getLeftOffset", "colorDecider", "pageType"]);
    var perBoxScore = end / (scale + start);
    var value = score === null || score === void 0 ? void 0 : score.toFixed(1);
    var targetPercentage = ["", "0%", "25%", "50%", "75%", "100%"];
    var scoreLeft = "0%";
    if (start == 1 && end == 5 && perBoxScore == 1) {
        scoreLeft = (_b = targetPercentage.at(target)) !== null && _b !== void 0 ? _b : "0%";
    }
    else {
        scoreLeft = "".concat(target * 10, "%");
    }
    // an array to create number of boxes
    var nums = new Array(scale).fill(0).map(function (v, i) {
        if (start == 0 && i > 0) {
            value -= perBoxScore;
        }
        if (start == 1) {
            value -= perBoxScore;
        }
        // value is used to display color boxes
        return value > perBoxScore ? perBoxScore : value >= 0 ? value : 0;
    });
    return (_jsxs("div", __assign({ className: styles.targetArrowContainer }, props, { children: [isProjectSingleSelect && pageType && (_jsx("div", __assign({ style: { position: "relative", top: "-26px" } }, { children: _jsx(ArrowIcon, { className: styles.targetArrow, fontSize: "large", sx: {
                        left: "calc(".concat(scoreLeft, " - ").concat(target == 5 || target == 10 ? 26 : 16, "px)"),
                    } }) }))), _jsx("div", __assign({ className: styles.boxesContainerMapping }, { children: nums === null || nums === void 0 ? void 0 : nums.map(function (n, i) {
                    return (_jsx(Box, { length: n, value: score, target: target, show: n + perBoxScore >= start &&
                            n < i * perBoxScore + perBoxScore &&
                            n >= 0 &&
                            (score == scale * perBoxScore + start
                                ? score <= start + perBoxScore * (i + 1)
                                : score < start + perBoxScore * (i + 1)) &&
                            score >= i * perBoxScore + start, isProjectSingleSelect: isProjectSingleSelect, aboveTargetColor: aboveTargetColor, belowTargetColor: belowTargetColor, perBoxScore: perBoxScore, getLeftOffset: getLeftOffset, colorDecider: colorDecider, pageType: pageType }, i));
                }) }))] })));
};
var AverageScore = function (_a) {
    var _b, _c, _d;
    var score = _a.score, target = _a.target, scale = _a.scale, start = _a.start, end = _a.end, getLeftOffset = _a.getLeftOffset, colorDecider = _a.colorDecider, aboveTargetColor = _a.aboveTargetColor, belowTargetColor = _a.belowTargetColor, _e = _a.isProjectSingleSelect, isProjectSingleSelect = _e === void 0 ? false : _e, pageType = _a.pageType;
    var scoreRounded = (_b = score === null || score === void 0 ? void 0 : score.toFixed(1)) !== null && _b !== void 0 ? _b : 0;
    var targetRounded = (_c = target === null || target === void 0 ? void 0 : target.toFixed(1)) !== null && _c !== void 0 ? _c : 0;
    var difference = (_d = Math.abs(Number(targetRounded) - Number(scoreRounded))) === null || _d === void 0 ? void 0 : _d.toFixed(1);
    return (_jsxs(_Fragment, { children: [_jsx(Scrollbar, { "data-testid": "AverageScore", score: score, target: target, start: start !== null && start !== void 0 ? start : 1, end: end !== null && end !== void 0 ? end : 5, isProjectSingleSelect: isProjectSingleSelect, scale: scale, aboveTargetColor: aboveTargetColor, belowTargetColor: belowTargetColor, getLeftOffset: getLeftOffset, colorDecider: colorDecider, pageType: pageType }), isProjectSingleSelect && pageType && (_jsx("div", __assign({ className: styles.averageScoreAboveBelowText }, { children: target &&
                    "Average is ".concat(difference, " ").concat(score >= target ? "above" : "below", " target (").concat(target === null || target === void 0 ? void 0 : target.toFixed(1), ")") })))] }));
};
export default AverageScore;
